import { DeleteOutline, Edit } from "@mui/icons-material";
import { IconButton, Paper, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DeleteModal from "../Modals/DeleteModal";

export default function BasicRewards() {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  // edit functions

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const [show, setShow] = useState(false);

  const [pointsValue, setPointsValue] = useState(null);

  const [editRewardId, setEditRewardId] = useState(null);

  const handleShow = (id, value) => {
    setShow(true);
    setPointsValue(value);
    setEditRewardId(id);
  };

  const handleClose = () => {
    setShow(false);
    setEditRewardId(null);
  };

  const handleSubmitnotify = async () => {
    const formData = new FormData();

    formData.append("_method", "PUT");

    formData.append("points", pointsValue);

    const url = `${newBaseUrl}/api/portal/user-action-points/${editRewardId}`;

    try {
      const response = await axios.post(url, formData, { headers });
      console.log(response);
      toast.success(response.data.data.message, { autoClose: 3000 });
      handleClose();
      getPoints();
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message, { autoClose: 3000 });
    }
  };

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useForm();

  //  delete functions

  const [showDelete, setShowDelete] = useState(false);

  const confirmDelete = (id) => {
    setShowDelete(true);
    setEditRewardId(id);
  };

  const handleDeleteClose = () => {
    setShowDelete(false);
    setEditRewardId(null);
  };

  const deleteReward = async () => {
    try {
      let response = await axios.delete(
        `${newBaseUrl}/api/portal/user-action-points/${editRewardId}`,
        {
          headers,
        }
      );
      toast.warning("Points Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      getPoints();
    } catch (error) {
      toast.error("Failed To Delete This Template.");
      console.log(error.message);
    }
  };

  // table functions

  const [points, setPoints] = useState([]);

  const getPoints = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/user-action-points`,
        { headers }
      );
      console.log(response.data.data.user_action_points);
      setPoints(response.data.data.user_action_points);
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "points",
      headerName: "Points",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "created",
      headerName: "Created_at",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "updated",
      headerName: "Updated_at",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1.1,
      minWidth: 150,
      renderCell: (params) => {
        const handleEdit = (event) => {
          event.stopPropagation();
          handleShow(params.row.id, params.row.points);
        };
        const handleDelete = (event) => {
          event.stopPropagation();
          confirmDelete(params.row.id);
        };
        return (
          <div>
            <IconButton onClick={handleEdit} color="info" aria-label="repeat">
              <Edit />
            </IconButton>
            <IconButton
              onClick={handleDelete}
              color="error"
              aria-label="delete"
            >
              <DeleteOutline />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const rows = points.map((point) => ({
    id: point.id,
    action: point.action,
    points: point.points,
    created: formatDate(point.created_at),
    updated: formatDate(point.updated_at),
    Actions: "",
    rawData: point,
  }));

  const paginationModel = { page: 0, pageSize: 10 };

  useEffect(() => {
    getPoints();
  }, []);

  return (
    <>
      {/* edit point value  */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            Edit Reward Value
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(handleSubmitnotify)}>
            <div className="col-9 mx-auto">
              <label htmlFor="points" className="mb-2">
                Points Value
              </label>
              <TextField
                type="number"
                id="points"
                placeholder="Enter Value"
                className="form-control mb-2"
                value={pointsValue}
                onChange={(e) => setPointsValue(e.target.value)}
              />
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* delete reward  */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this Reward?"}
        deleteFunction={deleteReward}
      />
      {/* points data  */}
      <div className="m-4 ">
        <div>
          <p className="my-sm-2 fs-5 my-md-0 fw-bold">Reward Items</p>
        </div>
        <div className=" border border-2 rounded-3 me-2 my-3 p-4">
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              initialState={{ pagination: { paginationModel } }}
              pageSizeOptions={[5, 10, 15]}
              checkboxSelectionو
              sx={{
                border: 0,
              }}
            />
          </Paper>
        </div>
      </div>
    </>
  );
}
